// Header mobile menu toggle. Deferred, runs once.
(function () {
  document.querySelectorAll('.mm-header').forEach(function (header) {
    var toggle = header.querySelector('.mm-header__toggle');
    var nav = header.querySelector('.mm-header__nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('.mm-header__sub-toggle')) return; // submenu toggles handled below
      if (e.target.tagName === 'A') {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Expand/collapse submenus inside the mobile drawer
    header.querySelectorAll('.mm-header__sub-toggle').forEach(function (st) {
      st.addEventListener('click', function (e) {
        e.preventDefault();
        var item = st.closest('.mm-header__nav-item--has-sub');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        st.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();
